/**
 * Точка входа React-приложения.
 * Рендерит корневой компонент App в DOM-элемент #root.
 * Регистрирует Service Worker для PWA.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Регистрация Service Worker для офлайн-доступа и установки PWA
serviceWorkerRegistration.register();
